import { Controller, FieldValues, useFormContext } from 'react-hook-form';
import { FormCertificateTypeSelectProps } from './types';
import { CertificateSelect } from '../../inputs/certificate-type-select/certificate-type-select';

export const FormCertificateTypeSelect = <T extends FieldValues>({
  name,
  items,
  placeholder,
  label,
  required = false,
  defaultLabel,
  defaultItemValue,
}: FormCertificateTypeSelectProps<T>) => {
  const { control } = useFormContext<T>();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, formState: { errors } }) => (
        <CertificateSelect
          label={label}
          required={required}
          onChange={field.onChange}
          items={items}
          selectedValue={field.value}
          placeholder={placeholder}
          error={errors[name]?.message as string}
          defaultLabel={defaultLabel}
          defaultItemValue={defaultItemValue}
        />
      )}
    />
  );
};
